// extracted by mini-css-extract-plugin
export var closeButton = "_a-1";
export var container = "_a-0";
export var fullModalImage = "_a-2";